import { useUrlQueryService } from "services/UrlQueryService/UrlQueryService";

const KEY = "matchingQuery";
export const useMatchingUrlQueryService = () => {
  return useUrlQueryService(KEY);
}
